// ProtectedRoute.jsx - Checks authentication before allowing access
import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "./UserContextPersistent";

const ProtectedRoute = ({ children }) => {
  const { state } = useUser();

  // Check if user is authenticated
  if (!state.isAuthenticated || !state.user) {
    console.log("User not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
